export default function PostLabel({
  children,
  className = '',
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <span
      className={`${className} rounded-full px-12 py-4 text-14 font-bold text-black theme--gradient-light hover:text-black s:text-12`}>
      {children}
    </span>
  )
}
